import { ar } from "../../../../date-fns/locale/ar.js";
window.dateFns = {
  ...window.dateFns,
  locale: {
    ...window.dateFns?.locale,
    ar
  }
};